import { hasPendingPayment } from '../payments/PendingPaymentHelper';

// TODO Move methods into @printdeal/business-logic

const disallowedLineItemStates = [
  'READY_FOR_FULFILLMENT',
  'SENT_TO_MCP',
  'SHIPPED',
  'FULFILLMENT_ACCEPTED',
  'FULFILLMENT_ERROR',
  'FULFILLMENT_REJECTED',
  'PRINTING_IN_PROGRESS',
  'DOC_REVIEW_IN_PROGRESS',
];

const areAllLineItemsCancelled = (lineItems, states) =>
  Boolean(lineItems.every((lineItem) => lineItem.state[0].state.id === states.lineItem.CANCELLED));

const isPayable = (order, states, lineItems, authResult) => {
  const adyenPending = hasPendingPayment(order.id);

  const DISALLOWED_ORDER_STATES = ['CANCELLED'].map((stateName) => states.order[stateName]);
  const DISALLOWED_PAYMENT_STATES = ['PAID', 'CREDIT_OWED'].map(
    (stateName) => states.payment[stateName],
  );

  if (authResult === 'AUTHORISED') {
    return false;
  }

  if (adyenPending) {
    return false;
  }

  if (DISALLOWED_ORDER_STATES.includes(order?.state?.id)) {
    return false;
  }

  if (areAllLineItemsCancelled(lineItems, states)) {
    return false;
  }

  if (DISALLOWED_PAYMENT_STATES.includes(order.paymentState)) {
    return false;
  }
  return true;
};

const needsPayment = (states, paymentState, adyenPending, authResult) => {
  const PAYMENT_NEEDED_ORDER_STATES = ['PENDING', 'BALANCE_DUE'].map(
    (stateName) => states.payment[stateName],
  );

  if (authResult === 'AUTHORISED') {
    return false;
  }

  if (adyenPending) {
    return false;
  }

  if (PAYMENT_NEEDED_ORDER_STATES.includes(paymentState)) {
    return true;
  }

  return false;
};

const canRemoveFile = (lineItem, lineItemStates) => {
  const [state] = lineItem.state;
  const disallowed = [...disallowedLineItemStates, 'DOC_REVIEW_IN_PROGRESS', 'CANCELLED', 'PROCESSING_CLOUDLAB_ARTWORK'];
  const DISALLOWED_LINE_ITEM_STATES = disallowed.map(
    (stateName) => lineItemStates[stateName],
  );

  return !DISALLOWED_LINE_ITEM_STATES.includes(state.state.id);
};

const canChangePaymentMethod = (states, lineItems) => {
  const ALLOWED_LINE_ITEM_STATES = [
    'INITIAL',
    'PROCESSING',
    'CONFIRMED',
    'WAITING_FOR_ARTWORK',
    'WAITING_FOR_DOC_REVIEW',
    'CANCELLED',
    'PROCESSING',
  ].map((stateName) => states.lineItem[stateName]);

  const allLineItemStateIds = lineItems.reduce((allIds, lineItem) => {
    const lineItemIds = lineItem.state.map(({ state }) => state.id);
    return allIds.concat(...lineItemIds);
  }, []);

  return ALLOWED_LINE_ITEM_STATES.includes(...allLineItemStateIds);
};

/**
 * @param customLineItems
 * @returns {number|*}
 *
 * TODO: LAUNCH-862 move this calculation step to the backend
 */
const getCustomerDiscountPrice = (customLineItems) => {
  if (customLineItems) {
    return customLineItems.filter((customLineItem) =>
      customLineItem.custom
        && customLineItem.custom.fields
        && customLineItem.custom.fields.lineItemType === 'customerDiscount')
      .reduce((accumulator, currentValue) => accumulator + currentValue.totalPrice.centAmount, 0);
  }
  return 0;
};

const reOrderableQuote = (currentLineItem, validationResults) => {
  if (validationResults?.length > 0 && currentLineItem.custom?.fields?.quoteId) {
    const matchedQuoteLineItem = validationResults.find(
      (quote) => quote.quoteId === currentLineItem.custom?.fields?.quoteId,
    );
    return matchedQuoteLineItem && matchedQuoteLineItem.isQuoteActive;
  }
  return false;
};

export {
  isPayable,
  canRemoveFile,
  areAllLineItemsCancelled,
  needsPayment,
  canChangePaymentMethod,
  getCustomerDiscountPrice,
  reOrderableQuote,
};
